var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33A3DC",
    d: "M28.8 51.3c-3.8 0-7-3.1-7-7v-7c0-11.5 9.4-20.9 20.9-20.9h7c3.8 0 7 3.1 7 7s-3.1 7-7 7h-7c-3.8 0-7 3.1-7 7v7c.1 3.8-3 6.9-6.9 6.9zM154.1 51.3c-3.8 0-7-3.1-7-7v-7c0-3.8-3.1-7-7-7h-7c-3.8 0-7-3.1-7-7s3.1-7 7-7h7c11.5 0 20.9 9.4 20.9 20.9v7c.1 4-3 7.1-6.9 7.1zM105.4 30.4H77.6c-3.8 0-7-3.1-7-7s3.1-7 7-7h27.8c3.8 0 7 3.1 7 7s-3.2 7-7 7zM91.5 155.7H77.6c-3.8 0-7-3.1-7-7s3.1-7 7-7h13.9c3.8 0 7 3.1 7 7s-3.2 7-7 7zM49.7 155.7h-7c-11.5 0-20.9-9.4-20.9-20.9v-7c0-3.8 3.1-7 7-7s7 3.1 7 7v7c0 3.8 3.1 7 7 7h7c3.8 0 7 3.1 7 7s-3.2 6.9-7.1 6.9zM28.8 107c-3.8 0-7-3.1-7-7V72.2c0-3.8 3.1-7 7-7s7 3.1 7 7V100c0 3.8-3.1 7-7 7zM154.1 93c-3.8 0-7-3.1-7-7V72.2c0-3.8 3.1-7 7-7s7 3.1 7 7v13.9c0 3.8-3.1 6.9-7 6.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#11395C",
    d: "M180.5 146.1l-65.7-65.7c-.9-.9-2-1.3-3.2-1.3-2.5 0-4.5 2-4.5 4.5V179c0 2.5 2 4.5 4.5 4.5 1.2 0 2.4-.5 3.3-1.4l27.3-28.3h35.1c2.5 0 4.5-2 4.5-4.5.1-1.2-.4-2.3-1.3-3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default ForwardRef;